import { Alert, Box, SpaceBetween } from '@cloudscape-design/components';

/**
 * Shown when a signed-in user is correctly authenticated (unlike
 * AccessRestricted, which blocks an entire email domain) but lacks the RBAC
 * permission/role a specific page or remote requires — e.g. a route-gated
 * admin page (RequirePermission) or a role-gated remote app
 * (remotes/pluginAccess).
 */
export default function AccessDenied() {
  return (
    <Box margin={{ top: 'xxxl' }} padding="xxl" textAlign="center">
      <SpaceBetween size="l">
        <Alert type="warning" header="Access denied">
          You don't have the permission required to view this page. Ask a platform
          administrator if you believe you should have access.
        </Alert>
      </SpaceBetween>
    </Box>
  );
}
